import { UpdateRepository } from "../repository/update_repository";

export class UpdateService {

    constructor() {
        this.updateRepository = new UpdateRepository();
    }

    async createUpdate(formData) {
        try {
            const response = await this.updateRepository.create(formData);
            return response.data;
        } catch (error) {
            console.error("Erro ao criar a atualização:", error);
            throw error;
        }
    }

    async fetchHistory() {
        try {
            const response = await this.updateRepository.fetchHistory();
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar histórico de atualizações:", error);
            throw error;
        }
    }

    async fetchRecentsUser(dominio) {
        try {
            const response = await this.updateRepository.fetchRecentsUser(dominio);
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar as atualizações recentes:", error);
            throw error;
        }
    }

    async toggleStatus(id) {
        try {
            const response = await this.updateRepository.toggleStatus(id);
            return response.data;
        } catch (error) {
            console.error(`Erro ao alterar status da atualização ${id}:`, error);
            throw error;
        }
    }

    async fetchPending(usuarioId, dominio) {
        try {
            const response = await this.updateRepository.fetchPending(usuarioId, dominio);
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar atualizações pendentes:", error);
            throw error;
        }
    }

    async markAsRead(atualizacaoId, usuarioId, dominio) {
        try {
            const response = await this.updateRepository.markAsRead(atualizacaoId, usuarioId, dominio);
            return response.data;
        } catch (error) {
            console.error(`Erro ao marcar a atualização ${atualizacaoId} como lida:`, error);
            throw error;
        }
    }
}